// Encode product ID to short hash for share links
// Shopify ID: "gid://shopify/Product/10290309923133" → extract number → base36
export function encodeProductId(shopifyId) {
  const num = shopifyId.replace(/\D/g, '');
  return BigInt(num).toString(36);
}

// Decode short hash back to Shopify ID
export function decodeProductId(hash) {
  try {
    // Parse base36 back to decimal using BigInt
    let result = BigInt(0);
    for (const char of hash) {
      result = result * BigInt(36) + BigInt(parseInt(char, 36));
    }
    return `gid://shopify/Product/${result.toString(10)}`;
  } catch {
    return null;
  }
}

// Generate share URL — uses SEO product page for proper OG previews
export function getShareUrl(product) {
  if (product.handle) {
    return `${window.location.origin}/product/${product.handle}`;
  }
  const code = encodeProductId(product.id);
  return `${window.location.origin}/?p=${code}`;
}

// Generate share text
export function getShareText(product) {
  return `Check out ${product.name} on binco! ${getShareUrl(product)}`;
}

// Share product using native share or clipboard
export async function shareProduct(product) {
  const url = getShareUrl(product);
  const text = `Check out ${product.name} on binco!`;

  if (navigator.share) {
    try {
      await navigator.share({ title: 'binco', text, url });
      return 'shared';
    } catch (e) {
      if (e.name === 'AbortError') return 'cancelled';
    }
  }

  // Fallback: copy to clipboard
  try {
    await navigator.clipboard.writeText(`${text} ${url}`);
    return 'copied';
  } catch {
    return 'failed';
  }
}

// Share site
export async function shareSite() {
  const url = window.location.origin;
  const text = 'binco - More Thrash For Less Cash';

  if (navigator.share) {
    try {
      await navigator.share({ title: 'binco', text, url });
      return 'shared';
    } catch {
      return 'cancelled';
    }
  }

  try {
    await navigator.clipboard.writeText(`${text} ${url}`);
    return 'copied';
  } catch {
    return 'failed';
  }
}
